import { FormGroup } from '@angular/forms';

export const extractMatchingSettings = (
  originalData: Record<string, any>,
  form: FormGroup
) => {
  const newSettings = { ...originalData };
  Object.entries(form.value).forEach(([key, value]) => {
    if (key in originalData) {
      newSettings[key] = value;
    }
  });

  return newSettings;
};
